import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';

import { Container, Row, Col, Nav } from 'react-bootstrap';

import Main from './Main';
import Settings from './Settings';
import Orders from './Orders';
import Equipment from './Equipment';
import Service from './Service';

class Account extends Component {
  componentDidMount() {
  }
  componentDidUpdate(type) {}   

  render() {
    return (
      <Container className="account my-5">
        <Row>
          <Col md={4}>
            <Nav variant="pills" class="flex-column">
              <Nav.Link href="/account">Профиль</Nav.Link>
              <Nav.Link href="/account/settings">Изменить данные</Nav.Link>
              <Nav.Link href="/account/orders">Мои заказы</Nav.Link>
              <Nav.Link href="/account/equipment">Моя техника</Nav.Link>
              <Nav.Link href="/account/service">Сервис</Nav.Link>
              <Nav.Link href="/account/">Выйти</Nav.Link>
            </Nav>
          </Col>
          <Col md={8}>
            <Route path='/account' exact component={ Main } />
            <Route path='/account/settings' exact component={ Settings } />
            <Route path='/account/orders' exact component={ Orders } />
            <Route path='/account/equipment' exact component={ Equipment } />
            <Route path='/account/service' exact component={ Service } />
          </Col>
        </Row>
      </Container>
    );
  };
}

Account.propTypes = {

}

const mapStateToProps = state => ({

});

export default connect(mapStateToProps, {  })(Account);